/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectLocations = (state: { locationToRole: any }) => state.locationToRole.locations;
export const selectLocationsLoading = (state: { locationToRole: any }) => state.locationToRole.loading;
export const selectLocationsError = (state: { locationToRole: any }) => state.locationToRole.error;
export const selectLocationsPaginationDetails = (state: { locationToRole: any }) => state.locationToRole.page;
